module.exports = __webpack_public_path__ + "tf.svg?eebbabd8c2002f491efdfabc420e6e0a";